<template>
    <section class="section is-medium">
        <div class="container">
            <div class="columns is-justify-content-space-between is-vcentered" :class="isImageRight ? 'is-flex-direction-row-reverse' : ''">
                <div class="column" :class="imgSize">
                    <Image :imageSrc="image" :imageAlt="imageAlt" class="textmedia" />
                </div>
                <div class="column" :class="txtSize">
                    <p class="title is-3" v-html="headline" />
                    <div v-html="content"></div>
                    <p v-if="buttonText">
                        <a v-if="buttonLink" :href="buttonLink" class="button mt-6 px-5 is-primary is-icon-arrow has-text-blue" target="_blank">{{buttonText}}</a>
                        <Button v-else :buttonText="buttonText" class="mt-6 px-5 is-primary is-icon-arrow has-text-blue" scrollTarget="#formTarget" />
                    </p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
// @ is an alias to /src
import Image from '@/components/Elements/Image.vue'
import Button from '@/components/Button.vue'

export default {
    name: 'Textmedia',
    components: {
        Image,
        Button
    },
    props: {
        buttonText: String,
        buttonHref: String,
        buttonClass: String,
        image: String,
        imageAlt: String,
        content: String,
        headline: String,
        imgSize: String,
        txtSize: String,
        buttonLink: String,
        isImageRight: Boolean
    }
}
</script>

<style lang="scss">
@import "@/styles/misc/vars.scss";
@import "@/styles/elements/textmedia.scss";
</style>